import PropTypes from 'prop-types';
import { Badge, Text } from '../../../ui-kit';
import {
  Action,
  Amount,
  Bottom,
  Container,
  Description,
  Divider,
  Item,
  NewGuestsTag,
  NewTagContainer,
  SubtotalAmount,
  Tooltip
} from './styles';
import * as COPY from './utilities/copy';

export const SummaryContent = ({ children, ...restProps }) => {
  return <Container {...restProps}>{children}</Container>;
};

SummaryContent.Action = ({ onClick, children, ...restProps }) => {
  return (
    <Action onClick={onClick} {...restProps}>
      {children}
    </Action>
  );
};

SummaryContent.Action.propTypes = {
  onClick: PropTypes.func
};

SummaryContent.Amount = ({ children, ...restProps }) => {
  return <Amount {...restProps}>{children}</Amount>;
};

SummaryContent.Bottom = ({ children, ...restProps }) => {
  return <Bottom {...restProps}>{children}</Bottom>;
};

SummaryContent.Description = ({ children, ...restProps }) => {
  return <Description {...restProps}>{children}</Description>;
};

SummaryContent.Divider = ({ ...restProps }) => {
  return <Divider {...restProps} />;
};

SummaryContent.Item = ({ children, ...restProps }) => {
  return <Item {...restProps}>{children}</Item>;
};

SummaryContent.NewTag = () => {
  return (
    <NewTagContainer>
      <Badge caps={false} variant={Badge.VARIANTS.DEEP_ORANGE_100}>
        New
      </Badge>
    </NewTagContainer>
  );
};

SummaryContent.NewGuestsTag = ({ splashText, ...restProps }) => {
  return (
    <NewGuestsTag {...restProps}>
      <Text as="span">{splashText ? splashText : COPY.NEW}</Text>
    </NewGuestsTag>
  );
};

SummaryContent.SubtotalAmount = ({ children, ...restProps }) => {
  return <SubtotalAmount {...restProps}>{children}</SubtotalAmount>;
};

SummaryContent.Tooltip = ({ children, ...restProps }) => {
  return <Tooltip {...restProps}>{children}</Tooltip>;
};
